/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { computed } from '@ember/object';
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import { SerializedLegacyAttributeFilter } from 'cio/types/conditions/legacy-filter';
import { deserializeFilter } from 'cio/utils/conditions/deserialize/attribute';

interface Signature {
  Args: {
    step: {
      branchIndex: number;
      future: boolean;
      action: ActionModel;
    };
  };
  Element: HTMLDivElement;
}

export default class MultiLang extends Component<Signature> {
  constructor(owner: unknown, args: Signature['Args']) {
    super(owner, args);
    this.args.step.action?.campaign.ensureParsedTree();
  }

  get defaultMessageName() {
    return this.defaultLanguageAction?.name ?? '';
  }

  get shortName() {
    return this.defaultLanguageAction?.info.shortName ?? '';
  }

  get defaultLanguageAction() {
    return this.args.step.action?.campaign.getConsolidatedActionsGroupDefaultActionByBranchActionId(
      this.args.step.action.id,
    );
  }

  @computed('args.step.{branchIndex,action}')
  get step() {
    return this.args.step;
  }

  get branchTaken() {
    let {
      branchIndex,
      action: { multiConditions },
    } = this.step;

    // The last path is always the "All others" path, so we can return early for that case.
    if (branchIndex === multiConditions.length) {
      return {
        lastPath: true,
      };
    }

    // Otherwise, let's get the condition for the branch that was taken so that we can extract
    // its value or name (for segments).
    let [condition] = multiConditions[branchIndex];
    if (condition == null) {
      return;
    }

    return deserializeFilter(condition as SerializedLegacyAttributeFilter);
  }

  // multiConditions is an array of conditions that are all the same type, the
  // same field. Only the value differs across different paths. We can look at
  // any condition to figure out the type, so we just look at the first one.
  get condition() {
    if (this.step == null) {
      return;
    }

    let [condition] = this.step.action.multiConditions.map((condition) => condition[0]);
    return condition;
  }

  // eslint-disable-next-line getter-return
  @computed('condition.{type,field}')
  get conditionName() {
    let { condition } = this;

    if (!condition) {
      return;
    }

    return (condition as SerializedLegacyAttributeFilter).field;
  }
}
